import React from 'react';
import AddProductForm from '../Components/Product/AddProduct/AddProductForm';

const AddProducts = () => {
	return (
		<div>
			<AddProductForm />
		</div>
	);
};

export default AddProducts;
